import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper'
import { provideHttpClient } from '@angular/common/http'
import { enableProdMode } from '@angular/core'
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations'
import { provideRouter } from '@angular/router'
import { provideStore } from '@ngrx/store'
import { provideStoreDevtools } from '@ngrx/store-devtools'
import player from 'lottie-web'
import { CookieService } from 'ngx-cookie-service'
import { provideLottieOptions } from 'ngx-lottie'
import { provideMarkdown } from 'ngx-markdown'
import { routes } from './app/app-routing.module'
import { AppComponent } from './app/app.component'
import { pageReducer, themeReducer, userReducer } from './app/ngrx/store/reducers'
import { httpInterceptorProviders } from './app/shared/models/HttpRequestInterceptor'
import { environment } from './environments/environment'

if (environment.production) {
  enableProdMode()
}

// Bootstrap the app: enable prod mode in production, then start AppComponent with providers for HTTP, routing, ngrx store, animations, lottie, cookies, markdown, and HTTP interceptors.
bootstrapApplication(AppComponent, {
  providers: [
    BrowserModule,
    BrowserAnimationsModule,
    provideAnimations(),
    provideHttpClient(),
    provideRouter(routes),
    provideStore({
      themeR: themeReducer,
      userR: userReducer,
      pageR: pageReducer,
    }),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: environment.production,
    }),
    provideLottieOptions({
      player: () => player,
    }),
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
    CookieService,
    httpInterceptorProviders,
    provideMarkdown(),
  ],
}).catch(err => console.error(err))
